import { render, staticRenderFns } from "./CreateDeal.vue?vue&type=template&id=594b8b83&scoped=true"
import script from "./CreateDeal.vue?vue&type=script&lang=js"
export * from "./CreateDeal.vue?vue&type=script&lang=js"
import style0 from "./CreateDeal.vue?vue&type=style&index=0&id=594b8b83&prod&lang=scss&scoped=true"
import style1 from "./CreateDeal.vue?vue&type=style&index=1&id=594b8b83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b8b83",
  null
  
)

export default component.exports